import React, { ReactNode } from "react";
import { Button } from "../Button";
import { ButtonDecline } from "../ButtonDecline";
import { Content } from "./styles";

interface Props {
  title: string;
  loading: boolean;
  children: ReactNode;
  btnTitle?: string;
  confirm: ()=> void;
  cancel: ()=> void;
}
export function Modal({ title, btnTitle, confirm, cancel, children,loading,...rest }: Props) {
  return(
    <Content
        title={title}
        visible={true}
        onCancel={cancel}
        footer={[
          <div className="actions">
          <ButtonDecline title="Cancelar" onClick={cancel} disabled={loading} />
          <Button title={btnTitle ? btnTitle : "Cadastrar"} onClick={confirm} loading={loading} />
          </div>
          
        ]}
        width="60%"
        maskStyle={{
          background: 'rgba(43, 43, 69, 0.8)'
        }}
      >
       {children}
      </Content>
  )
}
